import React from "react";
import { Link } from "react-router-dom";
import { Icon, fmtNum } from "../ui";
import { imageFor, sizedSrc } from "../../assets/characterImages";
import { personalize } from "../CharacterCard";
import "../../styles/content.css";

export const FLAG_LABEL = { white: "ธงขาว", green: "ธงเขียว", yellow: "ธงเหลือง", red: "ธงแดง" };
const FLAG_VALUES = ["ธงขาว", "ธงเขียว", "ธงเหลือง", "ธงแดง"];
const FEAT = { emoji: "☺️", music: "🎹", lore: "📖" };

/** ภาพปก: รูปจริงของตัวละคร ; ไม่มี/โหลดไม่ได้ = ภาพจาก manifest ตาม hash(id) (ไม่ใช้ DiceBear แล้ว — DiceBear เก็บไว้กับอวาตาร์ผู้ใช้)
 *  size: thumb (การ์ด) | med (ภาพใหญ่) — ขนาดกล่องคงที่จาก aspect-ratio ใน CSS จึงไม่มี layout shift */
export function Cover({ c, children, className = "char-card__img", style, size = "thumb", eager }) {
  const [broken, setBroken] = React.useState(false);
  const fb = React.useMemo(() => imageFor(c.id || c.name), [c.id, c.name]);
  const src = sizedSrc(c.image && !broken ? c.image : fb.file, size);
  return (
    <div className={className} style={{ background: fb.color, ...style }}>
      <img src={src} alt="" width={size === "thumb" ? 360 : 720} height={size === "thumb" ? 540 : 1080} loading={eager ? "eager" : "lazy"} decoding="async" onError={() => setBroken(true)} />
      {children}
    </div>
  );
}

/** การ์ดตัวละคร (ใช้ใน grid/carousel) — ชื่อ/แท็กอยู่บนภาพ ไล่เฉดมืดด้านล่าง ; onSave ถ้าส่งมาจะมีปุ่มบันทึก (คอลเลกชัน) */
export default function Card({ c, userName, saved, onSave }) {
  const tags = (c.tags || []).filter((t) => t !== "PG" && !FLAG_VALUES.includes(t)).slice(0, 2);
  return (
    <div style={{ position: "relative" }} className="char-card-wrap">
      <Link to={`/c/${c.id}`} className="char-card char-card--lux" aria-label={c.name}>
        <Cover c={c}>
          <span className="char-card__badges">
            {c.isFeatured ? <span className="badge badge--feat">แนะนำ</span> : null}
            {c.status && c.status !== "approved" && c.status !== "published" && c.status !== "active" ? <span className="badge badge--warn">{statusLabel(c.status)}</span> : null}
            {c.isArchived ? <span className="badge badge--warn">ซ่อนอยู่</span> : null}
            {FLAG_LABEL[c.flag] ? <span className="badge">{FLAG_LABEL[c.flag]}</span> : null}
          </span>
          <span className="char-card__meta">
            <span className="char-card__name clamp-1">{c.name}</span>
            <span className="char-card__tag clamp-2">{personalize(c.tagline, userName)}</span>
            <span className="char-card__foot">
              {tags.map((t) => <span key={t} className="char-card__tagchip">{t}</span>)}
              {(c.features || []).length ? <span className="char-card__feat" aria-hidden="true">{c.features.map((f) => <span key={f}>{FEAT[f]}</span>)}</span> : null}
              <span className="char-card__stat"><Icon name="chat" size={12} /> {fmtNum(c.messageCount)}</span>
            </span>
          </span>
        </Cover>
      </Link>
      {onSave ? (
        <button type="button" className={`char-card__like${saved ? " is-on" : ""}`} aria-label={saved ? "ยกเลิกบันทึก" : "บันทึกตัวละคร"} aria-pressed={!!saved} onClick={() => onSave(c)}>
          <Icon name="heart" size={16} filled={saved} />
        </button>
      ) : null}
    </div>
  );
}

export const statusLabel = (s) => ({ draft: "ร่าง", pending: "รออนุมัติ", hidden: "ซ่อน", rejected: "ไม่ผ่าน", approved: "เผยแพร่", published: "เผยแพร่", active: "เผยแพร่" }[s] || s);
